<template>
  <div class="card border-start border-start-width-2 border-start-primary">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <h6>Data de Criação:</h6>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <label class="form-label">Data Inicial:</label>
              <select class="form-select" v-model="filters.startCreatedAt">
                <option value="">Selecione</option>
                <option
                  v-for="createdAt in filtersSelects.createdAts"
                  :key="createdAt"
                  :value="createdAt"
                >
                  {{ dateTimeSqlToDateBR(createdAt) }}
                </option>
              </select>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">Data Final:</label>
              <select class="form-select" v-model="filters.endCreatedAt">
                <option value="">Selecione</option>
                <option
                  v-for="createdAt in filtersSelects.createdAts"
                  :key="createdAt"
                  :value="createdAt"
                >
                  {{ dateTimeSqlToDateBR(createdAt) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <h6>Data de Vencimento:</h6>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <label class="form-label">Data Inicial:</label>
              <select class="form-select" v-model="filters.startDueDate">
                <option value="">Selecione</option>
                <option
                  v-for="dueDate in filtersSelects.dueDates"
                  :key="dueDate"
                  :value="dueDate"
                >
                  {{ dateTimeSqlToDateBR(dueDate) }}
                </option>
              </select>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">Data Final:</label>
              <select class="form-select" v-model="filters.endDueDate">
                <option value="">Selecione</option>
                <option
                  v-for="dueDate in filtersSelects.dueDates"
                  :key="dueDate"
                  :value="dueDate"
                >
                  {{ dateTimeSqlToDateBR(dueDate) }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Centro de Custo:</label>
          <VueMultiselect
            :placeholder="
              filters.costCenters.length == 0
                ? 'Selecione'
                : `${filters.costCenters.length} itens selecionados`
            "
            :options="filtersSelects.costCenters"
            :multiple="true"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :hide-selected="false"
          >
            <template v-slot:option="{ option, isSelected }">
              <input
                type="checkbox"
                :id="option"
                :checked="isSelected"
                @change="
                  changeOption({
                    type: 'costCenters',
                    option: option,
                  })
                "
              />
              <label class="ms-2">
                {{ option }}
              </label>
            </template>
            <template v-slot:noOptions>Nenhuma opção</template>
          </VueMultiselect>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Usuário:</label>
          <VueMultiselect
            :placeholder="
              filters.users.length == 0
                ? 'Selecione'
                : `${filters.users.length} itens selecionados`
            "
            :options="filtersSelects.users"
            :multiple="true"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :hide-selected="false"
          >
            <template v-slot:option="{ option, isSelected }">
              <input
                type="checkbox"
                :id="option"
                :checked="isSelected"
                @change="
                  changeOption({
                    type: 'users',
                    option: option,
                  })
                "
              />
              <label class="ms-2">
                {{ option }}
              </label>
            </template>
            <template v-slot:noOptions>Nenhuma opção</template>
          </VueMultiselect>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">Fornecedor:</label>
          <VueMultiselect
            :placeholder="
              filters.providers.length == 0
                ? 'Selecione'
                : `${filters.providers.length} itens selecionados`
            "
            :options="filtersSelects.providers"
            :multiple="true"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :hide-selected="false"
          >
            <template v-slot:option="{ option, isSelected }">
              <input
                type="checkbox"
                :id="option"
                :checked="isSelected"
                @change="
                  changeOption({
                    type: 'providers',
                    option: option,
                  })
                "
              />
              <label class="ms-2">
                {{ option }}
              </label>
            </template>
            <template v-slot:noOptions>Nenhuma opção</template>
          </VueMultiselect>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">CNPJ:</label>
          <VueMultiselect
            :placeholder="
              filters.cnpjs.length == 0
                ? 'Selecione'
                : `${filters.cnpjs.length} itens selecionados`
            "
            :options="filtersSelects.cnpjs"
            :multiple="true"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :hide-selected="false"
          >
            <template v-slot:option="{ option, isSelected }">
              <input
                type="checkbox"
                :id="option"
                :checked="isSelected"
                @change="
                  changeOption({
                    type: 'cnpjs',
                    option: option,
                  })
                "
              />
              <label class="ms-2">
                {{ option }}
              </label>
            </template>
            <template v-slot:noOptions>Nenhuma opção</template>
          </VueMultiselect>
        </div>
      </div>
      <div class="text-end mt-3">
        <button
          type="button"
          class="btn btn-link"
          title="Limpar"
          @click="cleanFilterReport"
        >
          Limpar
        </button>
        <button
          type="button"
          class="btn btn-success rounded-pill me-2"
          title="Buscar"
          @click="filterReport"
        >
          <i class="ph-magnifying-glass me-2" />Buscar
        </button>
      </div>
    </div>
  </div>
  <div
    v-if="contractsPendents.length > 0"
    class="card p-0 table-responsive border-start border-start-width-2 border-start-primary"
  >
    <div class="d-flex align-items-center justify-content-between m-2">
      <p class="mb-0">Aprovações pendentes: {{ this.pendences.length }}</p>
      <p class="mb-0">
        Nota:
        <em>Os dados estão ordenados pela data de vencimento mais próxima</em>
      </p>
    </div>
    <div class="text-end mb-2">
      <button
        type="button"
        class="btn btn-outline-danger btn-icon"
        title="Exportar para PDF"
        @click="exportToPDF"
      >
        <i class="ph-file-pdf"></i>
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-icon mx-2"
        title="Exportar para Excel"
        @click="exportToExcel"
      >
        <i class="ph-microsoft-excel-logo"></i>
      </button>
    </div>
    <table class="table table-sm fs-sm">
      <thead class="bg-primary text-light">
        <tr>
          <th>Fornecedor</th>
          <th>CNPJ</th>
          <th>Usuário</th>
          <th>Data de Criação</th>
          <th>Vencimento</th>
          <th>Valor</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="measure in contractsPendents" :key="measure.id">
          <tr class="bg-success bg-opacity-20 fw-bold">
            <td>{{ measure.providerName }}</td>
            <td>{{ measure.cnpj }}</td>
            <td>{{ measure.createdBy }}</td>
            <td>{{ dateTimeRmToDateBR(measure.createdAt) }}</td>
            <td>{{ dateTimeSqlToDateBR(measure.dueDate) }}</td>
            <td>{{ formatToCurrencyBr(measure.totalValue) }}</td>
            <td class="text-center">
              <router-link
                v-if="measure.type === 'Contrato'"
                :to="`/documents/contracts/${measure.contractId}`"
              >
                <span class="badge bg-primary" title="Acessar">Acessar</span>
              </router-link>
              <router-link
                v-if="measure.type === 'Requisição'"
                :to="`/documents/moviments/${measure.idmov}`"
              >
                <span class="badge bg-primary" title="Acessar">Acessar</span>
              </router-link>
            </td>
          </tr>
          <tr v-for="item in measure.items" :key="item.id">
            <td colspan="2">{{ item.costCenter }}</td>
            <td colspan="3">{{ item.itemName }}</td>
            <td>{{ formatToCurrencyBr(item.totalValue) }}</td>
            <td></td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <div v-else class="card card-body">
    <p class="text-center mb-0">Nenhum resultado encontrado</p>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeSqlToDateBR, dateTimeRmToDateBR } from '@/utils/date'
import createPDF from '@/utils/pdf'
import createExcel from '@/utils/xlsx'
import '@/assets/css/vue-multiselect.css'

export default {
  name: 'PendenceTable',

  props: {
    pendences: {
      type: Array,
      required: true,
    },
  },

  components: {
    VueMultiselect,
  },

  data() {
    return {
      filtersSelects: {
        createdAts: '',
        dueDates: '',
        costCenters: [],
        users: [],
        providers: [],
        cnpjs: [],
      },
      filters: {
        startCreatedAt: '',
        endCreatedAt: '',
        startDueDate: '',
        endDueDate: '',
        costCenters: [],
        users: [],
        providers: [],
        cnpjs: [],
      },
      contractsPendents: [],
      formatToCurrencyBr,
      dateTimeSqlToDateBR,
      dateTimeRmToDateBR,
    }
  },

  methods: {
    createFilterSelects() {
      const createdAts = this.pendences.map(
        (measure) => measure.createdAt.split(' ')[0],
      )
      this.filtersSelects.createdAts = [...new Set(createdAts)].sort()

      const dueDates = this.pendences.map((measure) => measure.dueDate)
      this.filtersSelects.dueDates = [...new Set(dueDates)].sort()

      const costCenters = this.pendences.flatMap((measure) =>
        measure.items.map((item) => item.costCenter),
      )
      this.filtersSelects.costCenters = [...new Set(costCenters)].sort()

      const users = this.pendences.map((measure) => measure.createdBy)
      this.filtersSelects.users = [...new Set(users)].sort()

      const cnpjs = this.pendences.map((measure) => measure.cnpj)
      this.filtersSelects.cnpjs = [...new Set(cnpjs)].sort()

      const providers = this.pendences.map((measure) => measure.providerName)
      this.filtersSelects.providers = [...new Set(providers)].sort()
    },

    filterReport() {
      this.contractsPendents = this.pendences.filter((measure) => {
        let result = true
        if (this.filters.startCreatedAt) {
          result =
            result &&
            measure.createdAt >= `${this.filters.startCreatedAt} 00:00:00`
        }
        if (this.filters.endCreatedAt) {
          result =
            result &&
            measure.createdAt <= `${this.filters.endCreatedAt} 23:59:59`
        }
        if (this.filters.startDueDate) {
          result = result && measure.dueDate >= this.filters.startDueDate
        }
        if (this.filters.endDueDate) {
          result = result && measure.dueDate <= this.filters.endDueDate
        }
        if (this.filters.costCenters && this.filters.costCenters.length > 0) {
          result =
            result &&
            measure.items.some((item) =>
              this.filters.costCenters.some(
                (filterCostCenter) => item.costCenter === filterCostCenter,
              ),
            )
        }
        if (this.filters.users && this.filters.users.length > 0) {
          result =
            result &&
            this.filters.users.some((user) => measure.createdBy === user)
        }
        if (this.filters.providers && this.filters.providers.length > 0) {
          result =
            result &&
            this.filters.providers.some(
              (providerName) => measure.providerName === providerName,
            )
        }
        if (this.filters.cnpjs && this.filters.cnpjs.length > 0) {
          result =
            result && this.filters.cnpjs.some((cnpj) => measure.cnpj === cnpj)
        }
        return result
      })
    },

    changeOption(data) {
      const toggleOption = (type, option) => {
        const index = this.filters[type].findIndex((item) => item === option)
        if (index === -1) {
          this.filters[type].push(option)
        } else {
          this.filters[type].splice(index, 1)
        }
      }

      toggleOption(data.type, data.option)
    },

    cleanFilterReport() {
      this.filtersSelects = {
        createdAts: '',
        dueDates: '',
        costCenters: [],
        users: [],
        providers: [],
        cnpjs: [],
      }

      this.filters = {
        startCreatedAt: '',
        endCreatedAt: '',
        startDueDate: '',
        endDueDate: '',
        costCenters: [],
        users: [],
        providers: [],
        cnpjs: [],
      }

      setTimeout(() => {
        this.createFilterSelects()
      }, 150)

      this.filterReport()
    },

    exportToPDF() {
      const fileName = 'Medicoes_Pendentes'

      const head = [
        'Identificador',
        'Fornecedor',
        'CNPJ',
        'Usuário',
        'Data de Criação',
        'Vencimento',
        'Valor Total',
      ]

      const body = []

      this.contractsPendents.forEach((measure) => {
        const mainRow = [
          measure.type === 'Contrato' ? measure.contractId : measure.idmov,
          measure.providerName,
          measure.cnpj,
          measure.createdBy,
          dateTimeRmToDateBR(measure.createdAt),
          dateTimeSqlToDateBR(measure.dueDate),
          formatToCurrencyBr(measure.totalValue),
        ]

        body.push(mainRow)

        measure.items.forEach((item) => {
          const itemRow = [
            '',
            item.costCenter,
            '',
            item.itemName,
            '',
            '',
            formatToCurrencyBr(item.totalValue),
          ]
          body.push(itemRow)
        })
      })

      createPDF(fileName, head, body)
    },

    exportToExcel() {
      const fileName = 'Medicoes_Pendentes'

      const data = []

      this.contractsPendents.forEach((measure) => {
        const mainRow = {
          'Identificador':
            measure.type === 'Contrato' ? measure.contractId : measure.idmov,
          'Fornecedor': measure.providerName,
          'CNPJ': measure.cnpj,
          'Usuário': measure.createdBy,
          'Data de Criação': dateTimeRmToDateBR(measure.createdAt),
          'Vencimento': dateTimeSqlToDateBR(measure.dueDate),
          'Valor Total': formatToCurrencyBr(measure.totalValue),
        }

        data.push(mainRow)

        measure.items.forEach((item) => {
          const itemRow = {
            'Identificador': '',
            'Fornecedor': item.costCenter,
            'CNPJ': '',
            'Usuário': item.itemName,
            'Data de Criação': '',
            'Vencimento': '',
            'Valor Total': formatToCurrencyBr(item.totalValue),
          }
          data.push(itemRow)
        })
      })

      createExcel(fileName, data)
    },
  },

  mounted() {
    this.createFilterSelects()
    this.filterReport()
  },
}
</script>
